export default [
	{ id: 'unknown', name: 'unknown' },
	{ id: 'male', name: 'male' },
	{ id: 'female', name: 'female' }
];
